var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "date-fns", "emotion-theming", "../../../../i18nHelpers", "./GuideDaySlide.css", "../../themes", "../../utils", "@date-fns/upgrade/v2"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("date-fns"), require("emotion-theming"), require("../../../../i18nHelpers"), require("./GuideDaySlide.css"), require("../../themes"), require("../../utils"), require("@date-fns/upgrade/v2"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.dateFns, global.emotionTheming, global.i18nHelpers, global.GuideDaySlide, global.themes, global.utils, global.v2);
    global.GuideDaySlide = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _react, _propTypes, _dateFns, _emotionTheming, _i18nHelpers, _GuideDaySlide, _themes, _utils, _v) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _themes = _interopRequireDefault(_themes);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var GuideDaySlide = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(GuideDaySlide, _PureComponent);

    var _super = _createSuper(GuideDaySlide);

    function GuideDaySlide(props) {
      var _this;

      (0, _classCallCheck2.default)(this, GuideDaySlide);
      _this = _super.call(this, props);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClick", function () {
        _this.props.onClick(_this.props.date);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDateSelect", function (event) {
        if (event.keyCode === 13 || event.keyCode === 32) {
          _this.props.onClick(_this.props.date);
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFocus", function () {
        _this.props.onFocus(_this.props.date);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "formatDayName", function (date, dateLocale) {
        if (_this.props.theme !== 'presse') {
          if ((0, _dateFns.isToday)((0, _v.legacyParse)(date))) {
            return _this.translate('today');
          }

          if ((0, _dateFns.isYesterday)((0, _v.legacyParse)(date))) {
            return _this.translate('yesterday');
          }

          if ((0, _dateFns.isTomorrow)((0, _v.legacyParse)(date))) {
            return _this.translate('tomorrow');
          }
        }

        return (0, _dateFns.format)((0, _v.legacyParse)(date), (0, _v.convertTokens)('dddd'), {
          locale: dateLocale
        });
      });
      _this.translate = (0, _i18nHelpers.translateMe)(props.labels);
      return _this;
    }

    (0, _createClass2.default)(GuideDaySlide, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            date = _this$props.date,
            dateLocale = _this$props.dateLocale,
            daysAfter = _this$props.daysAfter,
            daysBefore = _this$props.daysBefore,
            isCurrent = _this$props.isCurrent,
            labels = _this$props.labels,
            theme = _this$props.theme;
        var selectionDate = "".concat(this.formatDayName(date, dateLocale), " ").concat((0, _dateFns.format)((0, _v.legacyParse)(date), this.translate('dayFormat'), {
          locale: dateLocale
        }));
        return /*#__PURE__*/_react.default.createElement(_emotionTheming.ThemeProvider, {
          theme: _themes.default[theme]
        }, /*#__PURE__*/_react.default.createElement(_GuideDaySlide.StyledSlideButton, {
          "aria-label": isCurrent && labels.infoSelectedDay ? (0, _utils.formatTranslation)(labels.infoSelectedDay, {
            selectionDate: selectionDate,
            daysBefore: daysBefore,
            daysAfter: daysAfter
          }) : '',
          onMouseDown: this.onClick,
          onKeyDown: this.onDateSelect,
          onFocus: this.onFocus,
          type: "button",
          isCurrent: isCurrent
        }, /*#__PURE__*/_react.default.createElement(_GuideDaySlide.StyledSlideName, null, this.formatDayName(date, dateLocale)), /*#__PURE__*/_react.default.createElement(_GuideDaySlide.StyledSlideDate, null, (0, _dateFns.format)((0, _v.legacyParse)(date), this.translate('dayFormat'), {
          locale: dateLocale
        }))));
      }
    }]);
    return GuideDaySlide;
  }(_react.PureComponent);

  GuideDaySlide.propTypes = {
    theme: _propTypes.default.string,
    isCurrent: _propTypes.default.bool,
    date: _propTypes.default.instanceOf(Date).isRequired,
    daysBefore: _propTypes.default.number,
    daysAfter: _propTypes.default.number,
    labels: _propTypes.default.shape({
      today: _propTypes.default.string,
      tomorrow: _propTypes.default.string,
      yesterday: _propTypes.default.string,
      dayFormat: _propTypes.default.string,
      infoSelectedDay: _propTypes.default.string
    }).isRequired,
    onClick: _propTypes.default.func.isRequired,
    dateLocale: _propTypes.default.shape().isRequired,
    onFocus: _propTypes.default.func
  };
  GuideDaySlide.defaultProps = {
    theme: 'next',
    labels: {
      today: 'Today',
      tomorrow: 'Tomorrow',
      yesterday: 'Yesterday',
      dayFormat: 'dd MMMM',
      infoSelectedDay: 'Votre sélection actuelle : %{selectionDate}. Vous pouvez consulter les programmes des %{daysBefore} jours avant et des %{daysAfter} jours après cette date.'
    },
    onClick: function onClick() {
      return console.log('GuideDaySlide.onClick is required');
    }
  };
  var _default = GuideDaySlide;
  _exports.default = _default;
});